import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getInitialData, logoutUser, refreshAndFetchData } from './features/user/userSlice';
import { Route, Routes } from 'react-router-dom';
import LoginForm from './components/auth/LoginForm';
import Dashboard from './components/dashboard/Dashboard';
import ProtectedRoute from './ProtectedRoute';
import Users from './components/users/Users';
import Profile from './components/users/Profile';
import ProjectForm from './components/projects/ProjectForm';
import Projects from './components/projects/Projects';
import CreateOrEditUser from './components/users/CreateOrEditUser';
import ResetPassword from './components/auth/ResetPassword';
import RecoveryPassword from './components/auth/RecoveryPassword';
import Nodes from './components/projects/nodes/Nodes';
import MatrixForm from './components/projects/matrix/MatrixForm';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const validateToken = async () => {
      const storedAccessToken = localStorage.getItem('refresh');
      const currentUrl = window.location.pathname;
      if (storedAccessToken) {
        try {
          await dispatch(refreshAndFetchData(storedAccessToken) as any)
            .then((result: any) => {
              if (getInitialData.fulfilled.match(result)) {
                // obtener current url

                if (currentUrl === '/') {
                  navigate('/dashboard');
                } else {
                  navigate(currentUrl);
                }
                // Redirige al usuario a /dashboard si la autenticación es exitosa
              }
            })
            .catch((error: any) => {
              console.error('Login failed:', error);
            });
        } catch (error) {
          dispatch(logoutUser());
          navigate(currentUrl);
        }
      } else {
        navigate(currentUrl);
      }
    };

    validateToken();
    // eslint-disable-next-line
  }, []);

  return (
    <Routes>
      <Route path='/' element={<LoginForm />} />
      <Route path='/reset-password/:uidb64/:token/' element={<ResetPassword />} />
      <Route path='/recovery-password' element={<RecoveryPassword />} />
      <Route element={<ProtectedRoute />}>
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/usuarios' element={<Users />} />
        <Route path='/usuario/:id/ver' element={<CreateOrEditUser viewOnly={true} />} />
        <Route path='/usuario/:id/editar' element={<CreateOrEditUser viewOnly={false} />} />
        <Route path='/usuario/nuevo' element={<CreateOrEditUser viewOnly={false} />} />
        <Route path='/perfil' element={<Profile />} />

        <Route path='/proyectos' element={<Projects />} />
        <Route path='/proyecto/nuevo' element={<ProjectForm />} />
        <Route path='/proyecto/:project_id/ver' element={<ProjectForm />} />
        <Route path='/proyecto/:project_id/nodos' element={<Nodes />} />

        <Route path='/proyecto/:project_id/matriz/nueva' element={<MatrixForm />} />
        <Route path='/proyecto/:project_id/matriz/:matrix_id/ver' element={<MatrixForm />} />

        <Route path='*' element={<LoginForm />} />
      </Route>
    </Routes>
  );
};

export default App;
